import { ReactNode } from 'react'

import { MileageRateConfigurationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { F0MileageInformation } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/MileageInformation/f0'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {
  rates?: MileageRateConfigurationFragment[]
  isCalculatingDistance?: boolean
  setIsCalculatingDistance?: (loading: boolean) => void
  divider?: boolean
  rightAction?: ReactNode
}

const MileageInformationSection = (props: Props) => {
  const { rates, setIsCalculatingDistance, divider, rightAction } = props

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.mileage_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.mileage_information_subtitle')}
      divider={divider}
      rightAction={rightAction}
    >
      <F0MileageInformation
        {...props}
        rates={rates}
        setIsCalculatingDistance={setIsCalculatingDistance}
      />
    </FormBlock>
  )
}

export default MileageInformationSection
